<script lang="ts">
    
    import { onDestroy, onMount } from "svelte";
    import type { SpriteAnimationDto, SpriteDto } from "../../global";

    export let animationName: string;
    export let play: boolean = false;
    export {
        sprite as src,
        animationName as animation,
     };

    let sprite: SpriteDto;
    let interval: number;
    let isPlaying = false;
    let image: HTMLImageElement;
    let canvas: HTMLCanvasElement;
    let animation: SpriteAnimationDto;
    let ctx: CanvasRenderingContext2D;
    let frame = -1;
    let imageReady = false;
    let canvasContainer: HTMLElement;
    let canvasWidth = 300;
    let canvasHeight = 300;

    $: setupSprite(sprite);
    $: setupAnimation(animationName);
    $: if (play) {
        playSprite();
    } else {
        stopSprite();
    }
    $: if (canvasContainer) {
        canvasWidth = canvasContainer.clientWidth;
        canvasHeight = canvasContainer.clientHeight;
    }
    $: if (canvas) {
        ctx = canvas.getContext('2d');
    }


    onMount(renderFirstFrameIfPaused);
    onDestroy(stopSprite);

    function setupSprite(sprite: SpriteDto): void {
        imageReady = false;
        image = new Image();
        image.addEventListener('load', () => {
            imageReady = true;
            renderFirstFrameIfPaused();
        });
        image.src = sprite.spriteUrl;
    }

    export function setupAnimation(animationName: string): void {
        animation = sprite.animations[animationName];
        frame = -1;
        renderFirstFrameIfPaused();
    }

    function renderFirstFrameIfPaused(): void {
        if (isPlaying) {
            return;
        }
        renderFrame(0);
    }

    export function playSprite(): void {
        if (isPlaying) {
            return;
        }
        isPlaying = true;
        interval = window.setInterval(updateSprite, 1000 / sprite.fps);
    }

    export function stopSprite(): void {
        if (!isPlaying) {
            return;
        }
        window.clearInterval(interval);
        interval = null;
        isPlaying = false;
        frame = 0;
        renderFrame(frame);
    }

    function updateSprite(): void {
        if (!imageReady || !ctx || !animation) {
            return;
        }
        frame++;
        if ((frame + 1) > animation.frames) {
            frame = 0;
        }
        renderFrame(frame);
    }

    function renderFrame(frame: number) {
        if (!imageReady || !ctx || !animation) {
            return;
        }

        const { width: frameWidth, height: frameHeight } = sprite.frameSize;
        const scale = Math.min(canvas.width / frameWidth, canvas.height / frameHeight);
        const finalWidth = frameWidth * scale;
        const finalHeight = frameHeight * scale;
        const finalLeft = canvas.width / 2 - finalWidth / 2;
        const finalTop = canvas.height / 2 - finalHeight / 2;

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(
            image,
            frameWidth * frame,
            frameHeight * animation.position,
            frameWidth,
            frameHeight,
            finalLeft,
            finalTop,
            finalWidth,
            finalHeight
        );
    }

</script>

<style lang="scss">

    .canvas-container {
        height: 100%;
    }

</style>

<div class="canvas-container" bind:this={canvasContainer}>
    <canvas
        style="width: {canvasWidth}px; height: {canvasHeight}px;"
        width={canvasWidth * 2}
        height={canvasHeight * 2}
        bind:this={canvas}></canvas>
</div>

